import React from 'react';
import PropTypes from 'prop-types';
import { decompressGzipBase64 } from 'app/shared/decoders/httpResponseDecoder';

import DebuggerContent from './shared/DebuggerContent';

export default function DebuggerDrawerResponseContent({ response }) {
  return (
    <DebuggerContent content={response} lang="text" decoder={gzipDecoder} emptyMessage="No response for this row." />
  );
}

function gzipDecoder({ encodedData }) {
  return decompressGzipBase64(encodedData);
}

DebuggerDrawerResponseContent.propTypes = {
  response: PropTypes.string,
};
